module.exports = __webpack_public_path__ + "static/Hero-mobile-carousel-546ab8ea539d414e3bfe268abd0798fd.jpg";